import React from "react";
import { OverviewContainer, OverviewHighlightText } from "~/components/ContextualHelpLayout/PageHelpRegistry/Registrations/CommonComponents/CommonViews";
import ExternalLink from "~/components/Navigation/ExternalLink/index";
export const CommonInsightsReportsView = () => (<OverviewContainer>
        <OverviewHighlightText>
            <p>
                <ExternalLink href="http://oc.to/SpaceLevelDevOpsInsights">Space-level DevOps Insights</ExternalLink> gives you a unified view of DORA metrics (deployment speed, failure rates, and recovery times) across multiple projects, so you can
                see what’s slowing deployments and optimize at scale.
            </p>
        </OverviewHighlightText>
    </OverviewContainer>);
